import React, { useCallback } from 'react';
import { useSelector, useDispatch } from '../../../lib/react-redux-hooks';
import { CircularProgress, Button, IconButton, Box } from '@material-ui/core';
import { X } from 'phosphor-react';

import * as types from '../../../actions/actionTypes';
import { updateSavedSearches } from '../../../actions/feed';
import ResponsiveDialog from '../../utility/ResponsiveDialog';
import { buttonStyles } from '../../../styles/base';

/**
 * @function DeleteSavedSearchDialog
 */
const DeleteSavedSearchDialog = () => {
  const dispatch = useDispatch();

  const { open, deleteSearchId, updateSaveSearch } = useSelector(
    (state: any) => {
      return {
        open: state.dialogs.deleteSearchDialogOpen,
        deleteSearchId: state.dialogs.deleteSearchId,
        updateSaveSearch: state.feed.updateSaveSearch,
      };
    },
  );

  const handleClose = useCallback(() => {
    if (open) {
      dispatch({ type: types.CloseDeleteSearchDialog });
    }
  }, [dispatch, open]);

  const saveSearchHandler = useCallback(() => {
    dispatch(updateSavedSearches(deleteSearchId, { saveSearch: false }));
  }, [deleteSearchId]);

  return (
    <ResponsiveDialog
      hideCloseButton
      className="save-search-dialog"
      onClose={handleClose}
      open={open}
      overrideFullScreen={false}
    >
      <Box maxWidth="420px">
        <Box
          fontWeight={700}
          fontSize="21px"
          color="#323232"
          mb={2}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box>Delete this saved search</Box>

          <IconButton
            aria-label="Close"
            style={{ padding: 0 }}
            onClick={handleClose}
          >
            <X size={24} weight="regular" />
          </IconButton>
        </Box>

        <Box fontSize="16px">
          Are you sure? You will no longer receive notifications for new
          listings matching this search.
        </Box>

        <Box display="flex" justifyContent="space-between" mt={3}>
          <Button
            variant="contained"
            size="medium"
            style={{
              ...buttonStyles.buttonMedium,
              height: '56px',
              width: '45%',
              padding: 5,
              background: '#FFFFFF',
              border: '1px solid #463264',
              color: '#463264',
              boxShadow: 'none',
            }}
            onClick={handleClose}
          >
            NEVERMIND
          </Button>

          <Button
            variant="contained"
            size="medium"
            style={{
              ...buttonStyles.buttonMediumBlue,
              height: '56px',
              padding: 5,
              width: '45%',
            }}
            disabled={updateSaveSearch?.saveSearchLoading}
            onClick={saveSearchHandler}
          >
            {updateSaveSearch?.saveSearchLoading ? (
              <CircularProgress
                size={24}
                variant="indeterminate"
                color="inherit"
              />
            ) : (
              'YES, DELETE'
            )}
          </Button>
        </Box>
      </Box>
    </ResponsiveDialog>
  );
};

export default DeleteSavedSearchDialog;
